import styled, { css } from 'styled-components';

import { color, spacing } from '~/theme';

export const TextFieldHintText = styled.p<{ readOnly: boolean }>`
    overflow-wrap: break-word;
    word-wrap: break-word;
    -ms-word-break: break-all;
    word-break: break-word;

    color: ${color.darkBtnHover};
    display: block;
    margin: 0 0 ${spacing.spacing4} 0;
    width: 100%;

    & span {
        display: block;
        max-width: 48rem;
    }

    & span:nth-child(2) {
        margin-top: ${spacing.spacing4};
    }

    ${props =>
        props.readOnly &&
        css`
            border: 0;
            clip: rect(0 0 0 0);
            height: 1px;
            margin: -1px;
            overflow: hidden;
            padding: 0;
            position: absolute;
            width: 1px;
        `}
`;

export const FieldsetHintText = styled(TextFieldHintText)`
    margin-left: ${spacing.spacing4};
`;

export default { TextFieldHintText, FieldsetHintText };
